<template>
  <div>
    <div >
      <transition name="modal" v-if="modalOpen">
        <div class="modal-mask" >
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-body">
                <slot name="body">
                  <div>
                    <md-steppers :md-active-step.sync="active" md-linear>
                      <md-step id="first" md-label="Select Image" :md-done.sync="first">
                        <md-content class="content-area md-scrollbar">
                          <image-select 
                             @save-image-to-catalogue="saveImageToCatalogue"
                            @process-file-array="processFileArray" 
                            @process-file-url="processFileUrl"></image-select>
                        </md-content>
                        <div class="flex bottom-buttons">
                          <div></div>
                          <button class="modal-default-button" @click="modalOpen = false">CANCEL</button>
                          <button class="modal-default-button" @click="$emit('close')">NEXT</button>
                        </div>
                      </md-step>

                      <md-step id="second" md-label="Edit Image" :md-done.sync="second">
                        <md-content class="content-area md-scrollbar">
                          <image-edit ref="imageEdit" @save-data="processFileArray" @save-image-to-catalogue="saveImageToCatalogue"></image-edit>
                        </md-content>
                        <div class="flex bottom-buttons">
                          <button class="modal-default-button" @click="setDone('second', 'first')">PREVIOUS</button>
                          <button class="modal-default-button" @click="modalOpen = false">CANCEL</button>
                          <button class="modal-default-button" @click="$refs.imageEdit.saveImageData()">NEXT</button>
                        </div>
                      </md-step>

                      <md-step id="third" md-label="Crop Image" :md-done.sync="third">
                        <md-content class="content-area md-scrollbar">
                          <image-crop ref="imageCrop" :aspectRatio="aspectRatio" @crop-data="gotCropData"></image-crop>
                        </md-content>
                        <div class="flex bottom-buttons">
                          <md-progress-spinner md-mode="indeterminate" v-if="showSpinner"></md-progress-spinner>
                          <button class="modal-default-button" @click="setDone('third', 'second')" v-if="!showSpinner">PREVIOUS</button>
                          <button class="modal-default-button" @click="modalOpen = false" v-if="!showSpinner">CANCEL</button>
                          <button class="modal-default-button" @click="showSpinner = true;$refs.imageCrop.getCropData();" v-if="!showSpinner">DONE</button>
                          <div></div>
                        </div>
                      </md-step>
                    </md-steppers>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import ModalButton from "../ModalButton.vue";
import ImageCrop from "../common/image/imageCrop";
import ImageEdit from "../common/image/imageEdit";
import ImageSelect from "../common/image/imageSelect";
import config from "../../config.json";

require("firebase/firestore");

export default {
  name: "modal",
  props: ["id", "widget"],
  components: {
      ModalButton, ImageCrop, ImageEdit, ImageSelect
  },
  watch: {
    modalOpen: function(val) {
      if(!val) {
        this.active = 'first';
        this.first = this.second = this.third = false;
      }
    }
  },
  data: function() {
    return {
      showSpinner: false,
      modalOpen: false,
      callback: null,
      active: 'first',
      first: false,
      second: false,
      third: false,
      aspectRatio: {},
      aspectRatios: {
        'image-full-width': {
          desktop: 16/9,
          mobile: 3/4
        },
        'image-standard': {
          desktop: 1,
          mobile: 3/4
        },
        'image-featured': {
          desktop: 16/9,
          mobile: 3/4
        },
        'image-circle': {
          desktop: false,
          mobile: 1,
          circle: true
        },
        'image-double': {
          desktop: false,
          mobile: 4/3
        },
        'preview-article-layout-default': {
          desktop: false,
          mobile: 3/2
        },
        'preview-article-layout-evergreen': {
          desktop: 3/2,
          mobile: 3/4
        },
        'preview-article-layout-featured': {
          desktop: 3/2,
          mobile: 3/4
        },
        'social': {
          desktop: false,
          mobile: 16/9
        },
        'article': {
          desktop: false,
          mobile: 'any'
        }
      }
    };
  },
  mounted: function() {

  },
  methods: {
    gotCropData: function(data) {
      var promises = [];
      var images = {
        mobile: false,
        desktop: false
      }
      if(data.mobile.done) {
        promises.push(
          firebase.storage().ref().child(`croppedImages/mobile_${Date.now()}_${Math.floor(Math.random()*9999999)}.jpg`).put(data.mobile.data).then((snapshot) => {
            return snapshot.ref.getDownloadURL().then((downloadURL) => {
                images.mobile = downloadURL;
            });
          })
        );
      }
      if(data.desktop.done) {
        promises.push(
          firebase.storage().ref().child(`croppedImages/desktop_${Date.now()}_${Math.floor(Math.random()*9999999)}.jpg`).put(data.desktop.data).then((snapshot) => {
            return snapshot.ref.getDownloadURL().then((downloadURL) => {
                images.desktop = downloadURL;
            });
          })
        );
      }
      Promise.all(promises).then(() => {
        console.log(images.mobile);
        
        this.callback(images);
        Vue.nextTick(() => {
          this.showSpinner = false;
          this.modalOpen = false;
        })
        
      })
    },
    saveImageToCatalogue: function(image) {
      if(image.data) {
        firebase.storage().ref().child(`croppedImages/${Date.now()}_${Math.floor(Math.random()*9999999)}_edited.jpg`).put(image.data).then((snapshot) => {
          return snapshot.ref.getDownloadURL().then((downloadURL) => {
            image.url = downloadURL;
            this.completeSaveImageToCatalogue(image);
          });

        });
      } else if(image.url) {
        this.completeSaveImageToCatalogue(image);
      } else {
        alert("Could not save image to database, no url or data supplied.");
      }

    },
    completeSaveImageToCatalogue: function(image) {
      return axios.post(config.apiAdmin + "/saveImage", {
        url: image.url, 
        searchString: image.searchString, 
        verificationString: "4oq367yvb6o9q346vbgp93q46b"
      });
    },
    processFileArray: function(data) {
      // TODO - Upload original image for use in the library here
      // axios.post(config.apiAdmin + "/saveImage", {
      //   url: downloadURL, 
      //   searchString: this.searchString, 
      //   verificationString: "4oq367yvb6o9q346vbgp93q46b"
      // });
      this.setDone('first', data.nextStep);

      var searchString=prompt("Please enter some text to find this image later","");
      if (name!=null){
        this.saveImageToCatalogue({
          data: data.bytes,
          searchString: searchString
        });
      }


      if(data.nextStep == "second")
        this.$refs['imageEdit'].openImageData(data.bytes);
      if(data.nextStep == "third")
        this.$refs['imageCrop'].openImageFromData(data.bytes);
    },
    processFileUrl: function(data) {
      // TODO - Upload original image for use in the library here
      this.setDone('first', data.nextStep);
      console.log(data);
      if(!data.catalogueImage) {
        var searchString=prompt("Please enter some text to find this image later","");
        if (name!=null){
          this.saveImageToCatalogue({
            url: data.url,
            searchString: searchString
          });
        }
      }


      if(data.nextStep == "second")
        this.$refs['imageEdit'].openImageUrl(data.url);
      if(data.nextStep == "third")
        this.$refs['imageCrop'].openImageFromUrl(data.url);
    },
    setDone (id, index) {
      this[id] = true

      if (index) {
        this.active = index;
      }
      console.log(this.active);
    },
    process: function(callback, item) {
      console.log("process", item);
      if(item.type) 
        this.aspectRatio = this.aspectRatios[item.type];
      this.callback = callback;
      this.modalOpen = true;

    }
  }
};
</script>


<style>
.md-stepper-header {
  height: 36px !important;
}
.md-stepper {
  padding:0 !important;
}
</style>
<style scoped>
.bottom-buttons {
  justify-content:center;
  margin:5px;
}
.bottom-buttons button {
  margin-left:5px;
  margin-right:5px;
}
.content-area {
  overflow-y: scroll;
  height: calc(98vh - 75px);
}
.x-button {
  margin-left: auto;
  cursor: pointer;
  font-size: 30px;
}
.modal-mask {
  overflow-y: scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: -212px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
img {
  max-width: 300px;
}
.flex1 {
  margin-left: 5px;
}
.flex1 h2 {
  margin: 0;
  border: none;
}
.flex1 p {
  margin: 3px 0 3px 0;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 98vh;
  color: black;
  display: flex;
  flex-direction: column;
  max-width: 98vw;
  margin: 0px auto;
  background-color: #5f5f5f;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
  .md-content {
    max-width: 100%;
    overflow: auto;
  }

/* .modal-default-button {

} */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding: 5px;
}
.modal-footer button {
  margin: 0 5px;
  height: 30px;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
  .video-scroll-button {
    display: none !important;
  }
}
.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;

  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.card {
  border: 1px solid white;
  width: 150px;
  flex: 0 0 auto;
  margin-right: 3px;
}
.card img {
  width: 150px;
}

.video-block {
  position: relative;
  margin-left: 20px;
  max-width: 300px;
}

input {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// imageWorkflow.vue?5f7209e4